<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00062.control.bottomMenu.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 1,
          label: 'P00062.control.modeFonctionnement.on' | translate,
          icon: 'fa-kit fa-picto-on',
          color: 'color-green',
        },
        {
          ref: 0,
          label: 'P00062.control.modeFonctionnement.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-red',
        },
        {
          ref: 2,
          label: 'P00062.control.modeFonctionnement.horloge' | translate,
          icon: 'fa-kit fa-picto-horloge',
          color: 'color-orange',
        },
      ]"
      [value]="this.actionStack!.getValue('\'ppCModeFonctionnement\'')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACPOLY_Controle,
          'ppCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00062.installation.regulation.consigne.value' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <div
      class="mode-control overflow-hidden temperature-slider"
      (click)="onClick($event)"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp($event)"
      (mouseleave)="onMouseUp($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <!-- Barre de progression -->
      <div
        class="position-absolute temperature-fill"
        [style.width.%]="getTempPercentage()"
        style="top: 0; bottom: 0; left: 0; transition: width 0.1s ease-out"
      ></div>

      <!-- Indicateur de température -->
      <div
        class="position-absolute"
        style="top: 0; bottom: 0; left: 0; right: 0; pointer-events: none"
      >
        <div class="row h-100 align-items-center">
          <div class="col fs-26">
            <div class="px-3">
              <i class="fa-kit fa-picto-teau"></i>
            </div>
          </div>
          <div class="col-auto fs-20">
            <div class="px-3">
              {{ getDisplayTemp() }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
